import axios from '../axios-config';

export interface ImpersonationRequest {
  userId: string;
}

export interface ImpersonationResponse {
  success: boolean;
  message: string;
  impersonatedUser: {
    id: string;
    email: string;
    fullName: string;
    role: string;
  };
}

export const impersonationService = {
  async impersonateUser(userId: string): Promise<ImpersonationResponse> {
    const response = await axios.post(`/api/Account/impersonate?Id=${userId}`, {
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json'
      }
    });
    
    return response.data;
  },

  async stopImpersonation(): Promise<void> {
    await axios.post('/api/Account/stop-impersonation', {}, {
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }
};
